export var STACK_CLASS_PREFIX = 'Stack';
export var STACK_ITEM_CLASS_PREFIX = 'StackItem';
export var stackRoot = 'StackRoot';
export var stackItemRoot = 'StackItemRoot';